import { useTranslation } from 'react-i18next';
import { BsChatText } from 'react-icons/bs';
import { type ButtonProps, Icon } from '@/ui';
import { useEntryModalContext } from '../contexts';
import { HeaderButton } from './HeaderButton';

type Props = ButtonProps & {
  hasMessages: boolean;
};

export const MessagesButton = ({ hasMessages, ...props }: Props) => {
  const { toggleSidebar, activeSidebarPanel } = useEntryModalContext();
  const { t } = useTranslation('entryModal', { keyPrefix: 'messages_panel' });

  return (
    <HeaderButton
      isActive={activeSidebarPanel === 'messages'}
      isHighlighted={hasMessages}
      leftIcon={<Icon as={BsChatText} pos="relative" top="-1px" />}
      onClick={() => toggleSidebar('messages')}
      {...props}
    >
      {t('button_label')}
    </HeaderButton>
  );
};
